/**
 * <purpose>Unified German date/time formatting for all ticket list views.</purpose>
 * <constraints>'short' omits time (tooltips provide full date). 'long' includes HH:MM.</constraints>
 */

export const formatRelativeTime = (dateStr: string, style: 'short' | 'long' = 'short'): string => {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dateDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const diffDays = Math.floor((today.getTime() - dateDay.getTime()) / 86400000);

  if (style === 'long') {
    if (diffMin < 1) return 'gerade eben';
    if (diffMin < 60) return `vor ${diffMin} Min.`;
    const hhmm = date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
    if (diffDays === 0) return `heute, ${hhmm}`;
    if (diffDays === 1) return `gestern, ${hhmm}`;
    if (diffDays < 7) return `${date.toLocaleDateString('de-DE', { weekday: 'long' })}, ${hhmm}`;
    return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit' });
  }

  // 'short' — compact relative label, no time
  if (diffMin < 1) return 'gerade';
  if (diffMin < 60) return `${diffMin} Min.`;
  if (diffDays === 0) return 'heute';
  if (diffDays === 1) return 'gestern';
  if (diffDays < 7) return ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'][date.getDay()];
  return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit' });
};

export const formatAbsoluteDate = (dateStr: string): string =>
  new Date(dateStr).toLocaleString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
